var order_number = '';
$(document).ready(function(){
  $('input[name="properties[AHV-Nr.]"]').inputmask("999.9999.9999.99");
  $.validator.addMethod("dateRange", function(value, element, params) {
    try {
      var year = value;
      if (year >= params.from && year <= params.to) {
        return true;
      }
    } catch (e) {}
    return false;
  });
  
  var fromDate = $('#courseBirthYearFrom').val();
  var toDate = $('#courseBirthYearUntil').val();
  
  $.validator.addClassRules({
    myDateFieldRangeValidate: {
      dateRange: {
        from: fromDate,
        to: toDate
      }
    }
  });
  
  $("#ContactForm-DOB").addClass("myDateFieldRangeValidate");

  jQuery("form.product-form").validate();
  jQuery.extend(jQuery.validator.messages, {
    required: "Dieses Feld ist erforderlich.",
    email: "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
    dateRange: 'Das Geburtsdatum muss zwischen '+getFormatedDate(fromDate)+' und '+getFormatedDate(toDate)+' liegen. Die angemeldete Person ist zu jung oder zu alt für dieses Camp.',
    accept: "Bitte fügen Sie einen gültigen Dateityp hinzu.",
  });

  $(document).on('click','.modalButton', function(){
    order_number = Math.floor(Math.random() * 10000000000);
  });

  $(document).on("click",".product-form form button[type='submit']", function () {
     var vari_ID = [];
     var vari_Title = [];
     var this_checked = $(this).parents('form').find('.field-crosssell-product input:checkbox:checked');     
     $(this_checked).each(function(i){
        vari_ID[i] = $(this).val(); 
        vari_Title[i] = $(this).attr('data-title');
     }); 
     if(vari_ID.length > 0){
       $(this).parents('form').find('button.product-form__submit.btn-in-stock').addClass('camp_cross_selling_submitter');
       $(this).parents('form').find('button.product-form__submit.btn-in-stock').attr('data-campid',vari_ID);       
       $(this).parents('form').find('input[name="properties[Zusatzliche]"]').val(vari_Title);
     }
     else {
       $(this).parents('form').find('button.product-form__submit.btn-in-stock').removeClass('camp_cross_selling_submitter');
       $(this).parents('form').find('button.product-form__submit.btn-in-stock').removeAttr('data-campid');     
       $(this).parents('form').find('input[name="properties[Zusatzliche]"]').val('');
     } 
  });

  $(document).on("change",".field-crosssell-product input[type='checkbox'][name='Zusatzliche[]']", function () {         
     var vari_ID = [];
     var vari_Title = [];     
     var this_checked = $(this).parents('form').find('.field-crosssell-product input:checkbox:checked');     
     $(this_checked).each(function(i){
        vari_ID[i] = $(this).val(); 
        vari_Title[i] = $(this).attr('data-title');
     }); 
     if(vari_ID.length > 0){
       $(this).parents('form').find('button.product-form__submit.btn-in-stock').addClass('camp_cross_selling_submitter');
       $(this).parents('form').find('button.product-form__submit.btn-in-stock').attr('data-campid',vari_ID);       
       $(this).parents('form').find('input[name="properties[Zusatzliche]"]').val(vari_Title);
     }
     else {
       $(this).parents('form').find('button.product-form__submit.btn-in-stock').removeClass('camp_cross_selling_submitter');
       $(this).parents('form').find('button.product-form__submit.btn-in-stock').removeAttr('data-campid');     
       $(this).parents('form').find('input[name="properties[Zusatzliche]"]').val('');
     }     
  });

  $(document).on("click",".overlay, .closeBtn", function () {
    $('.btn-out-of-stock').removeClass('loading');
    $('.btn-out-of-stock').find('.loading-overlay__spinner').addClass('hidden');
    $('.btn-out-of-stock').attr('aria-disabled',false);
    $('.btn-out-of-stock').attr('disabled',false);
    
    $('.form.product-form').children('.product-options-form').removeClass('hidden');
    $('.form.product-form').children('.product-checkout-form').addClass('hidden');
    $('.form.product-form').children('.btn-out-of-stock').addClass('hidden');
    
    $('.form.product-form').children('.product-checkout-form').find('.field__input').attr('disabled',true);
  });

  $(document).on('click','.next-step-button', function(){
    var $this = $(this);
    var $form = $this.parents('.form').attr('id');
    if(jQuery('form#'+$form).valid()){
      $('#'+$form).children('.product-options-form').addClass('hidden');
      $('#'+$form).children('.product-checkout-form').removeClass('hidden');
      $('#'+$form).children('.btn-out-of-stock').removeClass('hidden');
  
      $('#'+$form).children('.product-checkout-form').find('.field__input').attr('disabled',false);
    }
  });
  
  //on out of stock button click
  
  $(document).on('click','.btn-out-of-stock', function(){
    var $this = $(this);
    var $form = $this.parents('.form').attr('id');
    if(jQuery('form#'+$form).valid()){
      var form_product_name = $('#'+$form).find('[name="form_product_name"]').val();
      var form_product_id = $('#'+$form).find('[name="form_product_id"]').val();
      var form_product_qty = $('#'+$form).find('[name="form_product_qty"]').val();
      var form_product_sku = $('#'+$form).find('[name="form_product_sku"]').val();
      var product_price = $('#'+$form).find('[name="product_price"]').val();

      var vorname = $('#'+$form).children('.product-options-form').children('.contact__fields').find('[name="properties[Vorname]"]').val();
      var Name = $('#'+$form).children('.product-options-form').children('.contact__fields').find('[name="properties[Name]"]').val();
      var Name_des_Kindes = $('#'+$form).children('.product-options-form').children('.contact__fields').find('[name="properties[Name-des-Kindes]"]').val();
      var Geburtsdatum = $('#'+$form).children('.product-options-form').children('.contact__fields').find('[name="properties[Geburtsdatum]"]').val();
      var AHV = $('#'+$form).children('.product-options-form').children('.contact__fields').find('[name="properties[AHV-Nr.]"]').val();
      var Strasse = $('#'+$form).children('.product-options-form').children('.contact__fields').find('[name="properties[Strasse]"]').val();
      var PLZ = $('#'+$form).children('.product-options-form').children('.contact__fields').find('[name="properties[PLZ]"]').val();
      var Ort = $('#'+$form).children('.product-options-form').children('.contact__fields').find('[name="properties[Ort]"]').val();
      var Mobile = $('#'+$form).children('.product-options-form').children('.contact__fields').find('[name="properties[Mobile]"]').val();
      var Email = $('#'+$form).children('.product-options-form').children('.contact__fields').find('[name="properties[Email]"]').val();
      var Team = $('#'+$form).children('.product-options-form').children('.contact__fields').find('[name="properties[Team]"]').val();
      var Kategorie = $('#'+$form).children('.product-options-form').children('.contact__fields').find('[name="properties[Kategorie]"]').val();
      var Ausrüstung = $('#'+$form).children('.product-options-form').children('.contact__fields').find('[name="properties[Ausrüstung]"]:checked').val();
      var Lebensmittel = $('#'+$form).children('.product-options-form').children('.contact__fields').find('[name="properties[Lebensmittel Unverträglichkeit]"]').val();
      var Bemerkungen = $('#'+$form).children('.product-options-form').children('.contact__fields').find('[name="properties[Bemerkungen]"]').val();
      
      var checkout_fname = $('#'+$form).children('.product-checkout-form').children('.contact__fields').find('[name="checkout-first-name"]').val();
      var checkout_lname = $('#'+$form).children('.product-checkout-form').children('.contact__fields').find('[name="checkout-last-name"]').val();
      var checkout_strasse = $('#'+$form).children('.product-checkout-form').children('.contact__fields').find('[name="checkout-Strasse"]').val();
      var checkout_additional_address = $('#'+$form).children('.product-checkout-form').children('.contact__fields').find('[name="checkout-additional-address"]').val();
      var checkout_plz = $('#'+$form).children('.product-checkout-form').children('.contact__fields').find('[name="checkout-PLZ"]').val();
      var checkout_ort = $('#'+$form).children('.product-checkout-form').children('.contact__fields').find('[name="checkout-Ort"]').val();
      
      var b2c={
        "checkout_type": "waiting-list",
        "data": {
            "attributes": {
              "x-shopify-shop-domain":"fc-zurich.myshopify.com",
              "order_number": order_number,
              "name": form_product_name,
              "product_id": form_product_id,
              "quantity": form_product_qty,
              "sku": form_product_sku,
              "price": product_price,
              "checkout_vorname": checkout_fname,
              "checkout_nachname": checkout_lname,
              "checkout_strasse_und_hausnummer": checkout_strasse,
              "checkout_additional_address_2": checkout_additional_address,
              "checkout_plz": checkout_plz,
              "checkout_ort": checkout_ort,
              
            },
            'properties':[
              {
                "name": "Vorname",
                "value": vorname
              },
              {
                "name": "Name",
                "value": Name
              },
              {
                "name": "Name-des-Kindes",
                "value": Name_des_Kindes
              },
              {
                "name": "Geburtsdatum",
                "value": Geburtsdatum
              },
              {
                "name": "AHV-Nr.",
                "value": AHV
              },
              {
                "name": "Strasse",
                "value": Strasse
              },
              {
                "name": "PLZ",
                "value": PLZ
              },
              {
                "name": "Ort",
                "value": Ort
              },
              {
                "name": "Mobile",
                "value": Mobile
              },
              {
                "name": "Email",
                "value": Email
              },
              {
                "name": "Team",
                "value": Team
              },
              {
                "name": "Kategorie",
                "value": Kategorie
              },
              {
                "name": "Ausrüstung",
                "value": Ausrüstung
              },
              {
                "name": "Lebensmittel Unverträglichkeit",
                "value": Lebensmittel
              },
              {
                "name": "Bemerkungen",
                "value": Bemerkungen
              }
            ],
            'status': 'success'
        }
      }
  
      // console.log(JSON.stringify(b2c));
      $.ajax({
          url: "https://app.aico.swiss/19838/api/v1/ecommerce-orders/custom-checkout",
          // url: "https://ravip.free.beeceptor.com/ecommerce-orders/custom-checkout",
          type: "POST",
          data: JSON.stringify(b2c),
          headers:{"Authorization": "Bearer kxDrQOZfZyIJ28LrRRj3rHc3JUPbkW2NSucWbf5V", "Accept":'application/vnd.api+json', 'Content-type':'application/vnd.api+json'},
          beforeSend: function(){
            $this.addClass('loading');
            $this.find('.loading-overlay__spinner').removeClass('hidden');
            $this.attr('aria-disabled',true);
            $this.attr('disabled',true);
          },
          success: function (data) {
            $('#form_success').removeClass('hidden');
            
            $('#'+$form).children('.product-options-form').children('.contact__fields').find('input').val('');
            $('#'+$form).children('.product-options-form').children('.contact__fields').find('textarea').val('');
            $('#'+$form).children('.product-options-form').children('.contact__fields').find('input[type="checkbox"]').prop('checked', false);
            $('#'+$form).children('.product-options-form').children('.contact__fields').find('input[type="radio"]').prop('checked', false);
  
            $('#'+$form).children('.product-checkout-form').children('.contact__fields').find('input').val('');

            setTimeout(function(){
              $(".modal").fadeOut();
              $('#form_success').addClass('hidden');
            },5000);
          },
          complete:function(){
            $this.removeClass('loading');
            $this.find('.loading-overlay__spinner').addClass('hidden');
            $this.attr('aria-disabled',false);
            $this.attr('disabled',false);
  
            $('#'+$form).children('.product-options-form').removeClass('hidden');
            $('#'+$form).children('.product-checkout-form').addClass('hidden');
            $('#'+$form).children('.btn-out-of-stock').addClass('hidden');
      
            $('#'+$form).children('.product-checkout-form').find('.field__input').attr('disabled',true);
          },
          error:function(jqXHR, textStatus, errorThrown ){
            $('#form_error').removeClass('hidden');
            //console.log(textStatus);
          }
      });
    }
  });

  $(".camp-section .events-list").html($('.camp-section .events-list .events-subcategory ').sort(function(x, y) {
     var value_x = $(x).data('index');
     var arr_x = [];
     arr_x = value_x
          
     var value_y = $(y).data('index');
     var arr_y = [];
     arr_y = value_y

     var arel = parseInt( arr_x);
     var brel = parseInt(arr_y);             

    return arel < brel ? -1 : 1;
   }));
});